import React, { useEffect, useRef } from "react";

interface Props {
  onOutsideClick: () => void;
  children: React.ReactNode;
  isOpen: boolean;
}

const OutsideClickHandler: React.FC<Props> = ({ onOutsideClick, children, isOpen }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
      onOutsideClick();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return <div ref={wrapperRef}>{children}</div>;
};

export default OutsideClickHandler;
